import http from "axios";
import downloadHttp from "@/util/http";
export class CorporationApi {
  constructor() {
    /* require.ensure("../../util/http",(require)=>{
      let {http} = require( "../../util/http")
      this.post = http.post;
      this.get = http.get
      this.PREFIX = "/share-foreign"
    }) */
    this.post = http.post;
    this.get = http.get;
    this.PREFIX = "/share-foreign";
    this.downloadHttp = downloadHttp;
  }
  // 发送短信提示有领导审批
  sendWarningSms(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/sendBigLeaderWarningSms";
    return this.post(url, data);
  }
  /**
   * 获取集团户签团组立项列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  getList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/list";
    return this.post(url, data);
  }
  /**
   *接受立项
   *
   * @param {object} data
   * @param {String} data.itemInfoId - 立项id
   * @returns
   * @memberof CorporationApi
   */
  accept(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/receiveItem";
    return this.post(url, data);
  }
  /**
   *退回立项
   *
   * @param {object} data
   * @param {String} data.itemInfoId - 立项id
   * @param {String} data.returnReason - 退回原因
   * @returns
   * @memberof CorporationApi
   */
  fallback(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/fallbackItem";
    return this.post(url, data);
  }
  /**
   *立项
   *
   * @param {object} data
   * @param {String} data.itemInfoId - 立项id
   * @returns
   * @memberof CorporationApi
   */
  setProject(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/setProject";
    return this.post(url, data);
  }
  /**
   *立项
   *
   * @param {object} data
   * @param {String} data.itemInfoId - 立项id
   * @param {String} data.backable
   * @param {String} data.processInstName
   * @param {String} data.dynamicParams
   * @param {String} data.formModelData
   * @param {String} data.judgeable
   * @param {String} data.muCompleted
   * @param {String} data.processId
   * @returns
   * @memberof CorporationApi
   */
  submitApproval(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/submitItem";
    return this.post(url, data);
  }
  /**
   *立项开始-新
   *
   * @param {object} data
   * @param {String} data.dataId就是之前的itemInfoId
   * @param {String} data.title-流程名字
   * @param {String} data.fz_code-选择的分支
   * @returns
   * @memberof CorporationApi
   */
  workflowStart(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/submitItem";
    return this.post(url, data);
  }
  /**
   *获取已创建的文件
   *
   * @param {object} data
   * @param {object} data.itemInfoId - 立项id
   * @returns
   * @memberof CorporationApi
   */
  getFileList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/getFileList";
    return this.post(url, data);
  }
  /**
   *获取企业创建列表
   *
   * @param {object} data
   * @param {object} data.itemInfoId - 立项id
   * @returns
   * @memberof CorporationApi
   */
  getPublishFileList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/getPublishFileList";
    return this.post(url, data);
  }
  /**
   *获取流程日志
   *
   * @param {Object} data
   * @param {String} data.processInstId
   * @param {String} data.processId
   * @returns
   * @memberof CorporationApi
   */
  getDialog(data) {
    let url = this.PREFIX + "/flow/getProcessTaskFlow";
    return this.post(url, data);
  }
  // 流程意见
  getDialogNew(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/getApprovalDetail?processInstanceId="+data.processInstanceId+"&taskId="+data.taskId;
    return this.get(url);
  }
  /**获取流程信息
   */
  getProcessInfo(id) {
    let url = this.PREFIX + "/flow/getSingleApplication";
    return this.post(url, { applicationId: id });
  }
  /**
   *立项
   *
   * @param {object} data
   * @param {String} data.itemInfoId - 立项id
   * @param {String} data.backable -回退
   * @param {String} data.userRemark - 意见
   * @param {String} data.taskInstId -
   * @param {String} data.taskDefId -
   * @param {String} data.processId -
   * @param {String} data.processInstId -
   * @param {object} data.formModelData
   * @param {object} data.formModelData.applicationId
   * @param {object} data.formModelData.formId
   * @returns
   * @memberof CorporationApi
   */
  submitTask(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/submitTask";
    return this.post(url, data);
  }
  // 提交审批-同意不同意接口
  submitTaskNew(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/approve";
    return this.post(url, data);
  }
  // 查询可以退回的节点
  listReturn(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/listReturn?taskId="+data.taskId;
    return this.get(url);
  }
  // 退回审批---弃用
  taskReturn(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/return";
    return this.post(url, data);
  }
  taskReturnNew(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/reject";
    return this.post(url, data);
  }
  startCancelTask(data) {
    //发起人终止--没有这个场景，发起人发起之后会到已办，但是待办才有终止按钮
    //有这个场景--当审批人退回发起人，发起人就可以终止了--试看返回状态是不是4
    let url = this.PREFIX + "/workflow/stateItemInfo/cancelTask";
    return this.post(url,data);
  }
  // 撤回-取消
  withdrawTask(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/withdrawTask";
    return this.post(url,data);
  }
  // 判断是否展示集团领导选择框
  // 0 默认状态 1流程分支一王磊节点 2 发起人节点(包括撤回之后) 3 归档节点
  getPickLeaderFlag(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/getPickLeaderFlag";
    return this.post(url,data);
  }
  // 还原
  recoverPickLeaderFlag(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/recoverPickLeaderFlag";
    return this.post(url,data);
  }
  /**
   * 终止流程
   *
   * @author 王怀志
   * @param {object} data
   * @param {String} data.processId
   * @param {String} data.processInstId
   */
  endFlow(data) {
    let url = this.PREFIX + "/flow/endProcessTask";
    return this.post(url, data);
  }
  /**
   * 撤回审批
   *
   * @author 王怀志
   * @param {object} data
   * @param {String} data.processId
   * @param {String} data.processInstId
   * @param {String} data.taskInstId
   * @param {String} data.taskDefId
   */
  revokeFlow(data) {
    let url = this.PREFIX + "/flow/revokeTasks";
    return this.post(url, data);
  }
  /**
   * 获取流程走向条件
   * @param {object} data
   * @param  {String} data.processId
   * @param  {String} data.key - taskDefId
   */
  getCondition(data) {
    let url = this.PREFIX + "/flow/assignation/conditions";
    return this.post(url, data);
  }
  /**
   * 获取下个流程节点人员
   * @param {Object} data
   * @param {Object} data.employeeParam
   * @param {Object} data.employeeParam.orgEmployeeParam
   * @param {String[]} data.employeeParam.orgEmployeeParam.organizationIds
   */
  getOrganization(data) {
    let url = this.PREFIX + "/flow/getOrganizations";
    return this.post(url, data);
  }
  /**
   * 获取集团所有人员
   */
  getAllOrganizations() {
    let url = this.PREFIX + "/visa/stateItemInfo/getAllOrganizations";
    return this.post(url);
  }
  /**
   * 根据部门节点获取人员列表
   * @param {object} data - query 参数对象，按字段原样拼到 URL
   */
  getUserByOrg(data) {
    const query = new URLSearchParams(data).toString();
    let url = `/aaas-data-discovery/user/page?${query}`;
    return this.get(url);
  }
  // 获取集团领导
  pagePersonnel(data) {
    let url = "/aaas-data-discovery/user/searchUserOfOrg";
    return this.post(url,data);
  }
  // 判断是否有加签权限
  getProcessModelItem(data) {
    let url = this.PREFIX + "/flow/getProcessModelItem";
    return this.post(url,data);
  }
  // 加签
  nodeCoSign(data) {
    let url = this.PREFIX + "/flow/nodeCoSign";
    return this.post(url,data);
  }
  // 加签新
  createSign(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/createSign";
    return this.post(url,data);
  }
  /**
   * 获取指定节点模型
   * @param {Object} data
   * @param {String} data.processId
   * @param {String} data.key
   */
  getAssignation(data) {
    let url = this.PREFIX + "/flow/assignation";
    return this.post(url, data);
  }
  getApplicationId() {
    let url = this.PREFIX + "/flow/getPublishedApplication";
    return this.post(url, {});
  }
  /**
   * 撤回任务
   *
   * @param {Object} data
   * @param {String} data.taskId
   */
  recallTask(data) {
    let url = this.PREFIX + "/visa/infoTask/recallTask";
    return this.post(url, data);
  }
  getNodeDict() {
    let url = this.PREFIX + "/common/getTaskNode";
    return this.post(url, {});
  }

  /**
   *
   * 点击人员获取可选国家
   *
   */
  getVisaItemByPerson(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemByPerson";
    return this.post(url, data);
  }

  /**
   * 点击国家获取可选人员
   *
   *
   */
  getVisaItemByCountry(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemByCountry";
    return this.post(url, data);
  }

  // 申办签证回显人员港澳证是否销旧办新
  getVisaItemUserByCountry(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemUserByCountry";
    return this.post(url, data);
  }

  // 导出
  exportList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/exportList";
    return this.downloadHttp.download2(url, data);
  }
  // 导出因公出访情况统计
  visitPlanExport(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/visitPlanExport";
    return this.downloadHttp.download3(url, data);
  }
}

export default class CompanyApi {
  constructor() {
    /*  require.ensure("../../util/http",(require)=>{
       let {http} = require( "../../util/http")
       this.post = http.post;
       this.get = http.get
       this.PREFIX = "/share-foreign"
     }) */
    this.post = http.post;
    this.get = http.get;
    this.PREFIX = "/share-foreign";
    this.downloadHttp = downloadHttp;
  }
  /**
   * @author 王怀志
   * @param {Object} data
   * @param {String} data.itemInfoId
   */
  canCreateTask(data) {
    let url = this.PREFIX + "/visa/infoTask/isCreateTask";
    return this.post(url, data);
  }
  // /visa/infoTask/getApecPerson
  /**
   * @author 傅帅杰
   * @param {Object} data
   * @param {String} data.itemInfoId
   */
  getApecPerson(data) {
    let url = this.PREFIX + "/visa/infoTask/getApecPerson";
    return this.post(url, data);
  }

  /**
   * @author 王怀志
   * @description 下属企业办理签证、护照、出入境证明
   * @param {Object} data
   * @param {String} data.country 国家
   * @param {String} data.bizId 业务id
   * @param {String} data.transActors 接收人
   * @param {String[]} data.personInfoIds 人员
   * @param {String} data.type 任务类型:1护照,2签证,4出入境证明
   */
  submitCompanyTask(data) {
    let url = this.PREFIX + "/visa/infoTask/startInfoTask";
    return this.post(url, data);
  }
  //修改出、回国（镜）日期后提交
  submitDateChanged(data) {
    let url = this.PREFIX + "/visa/visaInfo/updateTime";
    return this.post(url, data);
  }
  /**
   * @author 相广震
   * @description 取走证明/护照/签证
   * @param {Object} data
   * @param {String} data.type 取走类型：1快递，2自取
   * @param {String} data.courier 快递公司
   * @param {String} data.courierNum 快递单号
   * @param {String} data.recipient 接收人/去走人
   * @param {String} data.recipientTel 接收人/去走人手机号
   * @param {String} data.remark 备注
   * @param {String} data.issueTime 开放时间
   */
  addTakes(data) {
    let url = this.PREFIX + "/visa/infoTask/addTakes";
    return this.post(url, data);
  }
  /**
   * @author 相广震
   * @description 查看取走信息
   * @param {Object} data
   * @param {String} data.taskId task任务id
   */
  getTakesInfo(data) {
    let url = this.PREFIX + "/visa/infoTask/getTakesInfo";
    return this.post(url, data);
  }
  /**
   * @author 张凤娇
   * @description 通过takeId获取取走信息
   * @param {Object} data
   * @param {String} data.takeId 取走任务id
   */
  getDetailByTakeId(data) {
    let url = this.PREFIX + "/visa/infoTask/getTakesInfoById";
    return this.post(url, data);
  }
  /**
   * 查询最后一次完成的任务
   *
   * @author 王怀志
   * @param {{personInfoId: String}} data
   */
  getLastTask(data) {
    let url = this.PREFIX + "/visa/personInfo/getLastTask";
    return this.post(url, data);
  }
  /**
   * @author 相广震
   * @description 批量修改立项状态
   * @param {Object} data
   * @param {String} data.status 立项状态：140已完成,150未成行
   * @param {String} data.itemInfoIds 立项id
   */
  batchSetStatus(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/batchSetStatus";
    return this.post(url, data);
  }
  /**
   * 获取集团办理护照列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  passportTaskList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/passportTaskList";
    return this.post(url, data);
  }
  /**
   * 获取集团出入境证明列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  exitTaskList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/exitCertTaskList";
    return this.post(url, data);
  }
  /**
   * 获取签证待取走列表
   *
   * @author 王怀志
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  visaTakeAwayList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/visaTaskTakeAwayList";
    return this.post(url, data);
  }
  /**
   * 获取护照待取走列表
   *
   * @author 王怀志
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  passportTakeAwayList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/passportTaskTakeAwayList";
    return this.post(url, data);
  }
  /**
   * 获取出入境待取走列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  exitCertTaskTakeAway(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/exitCertTaskTakeAwayList";
    return this.post(url, data);
  }
  /**
   * 取回/护照/签证
   * @param {Object} data
   * @param {String} data.taskId
   */
  getTakeBack(data) {
    let url = this.PREFIX + "/visa/infoTask/takeBack";
    return this.post(url, data);
  }
  getTakeBackNew(data) {
    let urlnew = this.PREFIX + "/visa/infoTask/takeBackMfa";
    return this.post(urlnew, data);
  }
  /**
   * 取回/护照/签证
   * @param {Object} data
   * @param {String} data.taskId
   */
  getTakeBackGroup(data) {
    let url = this.PREFIX + "/visa/infoTask/batchTakeBack";
    return this.post(url, data);
  }
  getTakeBackGroupNew(data) {
    let url = this.PREFIX + "/visa/infoTask/batchTakeBackMfa";
    return this.post(url, data);
  }
  /**
   * @description 接受任务
   * @param {Object} data
   * @param {String} data.taskId
   */
  receiverTask(data) {
    let url = this.PREFIX + "/visa/infoTask/receiveTask";
    return this.post(url, data);
  }
  /**
   * @description 驳回任务
   * @param {Object} data
   * @param {String} data.taskId
   * @param {String} data.remark
   */
  rejectTask(data) {
    let url = this.PREFIX + "/visa/infoTask/backTask";
    return this.post(url, data);
  }

  /**
   * @description 接收任务
   * @param {Object} data
   * @param {String} data.taskId
   */
  acceptTask(data) {
    let url = this.PREFIX + "/visa/apec/updateStatus";
    return this.post(url, data);
  }
  /**
   * 获取集团办理签证列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 收文编号
   * @param {string} data.groupBatchNo 批件号
   */
  visaTaskList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/visaTaskList";
    return this.post(url, data);
  }
  /**
   * 获取公司户签团组立项列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 批件号
   */
  getCompanySetupList(data) {
    let url = this.PREFIX + "/stateItemInfo/getListOfCompany";
    return this.post(url, data);
  }
  /**
   * 获取公司户签团组立项列表
   *
   * @param {object} data
   * @param {string} data.teamName 团组名称
   * @param {string} data.tuxUnit 组团单位
   * @param {string} data.status 立项状态,已创建10  已上报20 已立项40 处理中70 已完成140
   * @param {string} data.preDepaDateStart 出境开始日期
   * @param {string} data.preDepaDateEnd 出境结束日期
   * @param {string} data.receiveNo 批件号
   */
  getSetupGt60(data) {
    let url = this.PREFIX + "/stateItemInfo/getListOfCompanygt60";
    return this.post(url, data);
  }
  /**
   * 新增团组
   *
   * @param {object} data
   * @param {string} data.teamDesc -团组描述
   * @param {string} data.visitCountryCode -出访国家code,多个用中文顿号分割
   * @param {string} data.visitCountryName -出访国家name
   * @param {string} data.teamType -团组类型1因公，2因私
   * @param {string} data.taskTypeName -任务类型名称
   * @param {string} data.taskType -任务类别
   * @param {string} data.visitPurpose -出访目的
   * @param {string} data.signer -签发人
   * @param {string} data.firstName -团长姓
   * @param {string} data.lastName -团长名
   * @param {string} data.outPlace -启程地点
   * @param {string} data.preDepaDate -出境日期
   * @param {string} data.twoSpan -是(Y)否(N)双跨团组
   * @param {string} data.outsideNum -在外天数
   * @param {string} data.tuxUnit -组团单位id
   * @param {string} data.tuxUnitName -组团单位名称
   * @param {string} data.teamPerNum -团组总人数
   * @param {string} data.ourPerNum -我方人数
   * @param {string} data.proNew - 是(Y)否(N)新项目
   * @param {string} data.tuxTaskBatchNo -组团单位任务批件文号
   * @param {string} data.entApplyNo -企业申报文号
   * @param {string} data.remarks -备注
   * @param {string} data.costAdded -费用补充说明
   * @param {string} data.costSource -费用来源(字典)
   * @param {string} data.agentName -经办人
   * @param {string} data.agentId -经办人id
   * @param {string} data.agentTel -经办人电话
   * @param {string} data.agentPhone -经办人手机
   * @param {string} data.agentMail -经办人邮箱
   * @param {object[]} [data.fileList] -文件列表
   * @param {string} data.fileId -文件id
   * @param {string} data.type -附件类型 1立项请示，2备案表，3邀请函，4培训证明
   */
  add(data) {
    let url = this.PREFIX + "/stateItemInfo/add";
    return this.post(url, data);
  }
  /**
   * 设置状态
   *
   * @param {object} data
   * @param {number} data.status - 状态,60审批通过,70护照办理中,80护照已取回,90签证办理中,100签证已取回,110护照已取走,120签证已取走,130出境证明已办理,140已完成,150未成行
   * @param {string} data.itemInfoId - 立项id
   * @param {string} data.submitVisitReport - 是(Y)否(N)已提交出访报告
   */
  updateStatus(data) {
    let url = this.PREFIX + "/stateItemInfo/updateStatus";
    return this.post(url, data);
  }
  /**
   *删除立项
   *
   * @param {object} data
   * @param {string} data.itemInfoId - 立项id
   * @returns
   * @memberof CompanyApi
   */
  delItem(data) {
    let url = this.PREFIX + "/stateItemInfo/deleteItem";
    return this.post(url, data);
  }
  /**
   * 编辑团组
   *
   * @param {object} data
   * @param {string} data.teamDesc -团组描述
   * @param {string} data.visitCountryCode -出访国家code,多个用中文顿号分割
   * @param {string} data.visitCountryName -出访国家name
   * @param {string} data.teamType -团组类型1因公，2因私
   * @param {string} data.taskTypeName -任务类型名称
   * @param {string} data.taskType -认为类别
   * @param {string} data.visitPurpose -出访目的
   * @param {string} data.signer -签发人
   * @param {string} data.firstName -团长姓
   * @param {string} data.lastName -团长名
   * @param {string} data.outPlace -启程地点
   * @param {string} data.preDepaDate -出境日期
   * @param {string} data.twoSpan -是(Y)否(N)双跨团组
   * @param {string} data.outsideNum -在外天数
   * @param {string} data.tuxUnit -组团单位id
   * @param {string} data.tuxUnitName -组团单位名称
   * @param {string} data.teamPerNum -团组总人数
   * @param {string} data.ourPerNum -我方人数
   * @param {string} data.proNew - 是(Y)否(N)新项目
   * @param {string} data.tuxTaskBatchNo -组团单位任务批件文号
   * @param {string} data.entApplyNo -企业申报文号
   * @param {string} data.remarks -备注
   * @param {string} data.costAdded -费用补充说明
   * @param {string} data.costSource -费用来源(字典)
   * @param {string} data.agentName -经办人
   * @param {string} data.agentId -经办人id
   * @param {string} data.agentTel -经办人电话
   * @param {string} data.agentPhone -经办人手机
   * @param {string} data.agentMail -经办人邮箱
   * @param {string} data.itemInfoId -立项id
   * @param {object[]} [data.fileList] -文件列表
   * @param {string} data.fileId -文件id
   * @param {string} data.type -附件类型 1立项请示，2备案表，3邀请函，4培训证明
   */
  update(data) {
    let url = this.PREFIX + "/stateItemInfo/update";
    return this.post(url, data);
  }
  /**
   *有特殊成员，出访计划选择否，但是未列入出访计划说明函被删除时，也可以上报问题修复接口
   */
  updateIfVisitPlan(data) {
    let url = this.PREFIX + "/stateItemInfo/updateIfVisitPlan";
    return this.post(url, data);
  }
  /**
   *获取团组总览
   *
   * @param {object} data
   * @param {string} data.itemInfoId
   * @returns
   * @memberof CompanyApi
   */
  getOverview(data) {
    let url = this.PREFIX + "/stateItemInfo/stateItemDetail";
    return this.post(url, data);
  }

  getVisaItemDetailsStateById(data) {
    let url = this.PREFIX + "/visa/visaItem/getVisaItemDetailsStateById";
    return this.post(url, data);
  }
  /**
   *查询立项详情
   *
   * @param {object} data
   * @param {string} data.groupBatchNo
   * @param {string} data.companyId
   * @returns
   * @memberof CompanyApi
   */
  stateItemDetailByBatchNo(data) {
    let url = this.PREFIX + "/stateItemInfo/stateItemDetailByBatchNo";
    return this.post(url, data);
  }
  /**
   *获取立项详情
   *
   * @param {object} data
   * @param {string} data.itemInfoId
   * @returns
   * @memberof CompanyApi
   */
  getDetail(data) {
    let url = this.PREFIX + "/stateItemInfo/getStateItemBasicInfo";
    return this.post(url, data);
  }
  /**
   *获取简易立项详情,没有图片的
   *
   * @param {object} data
   * @param {string} data.itemInfoId
   * @returns
   * @memberof CompanyApi
   */
  getSimpleDetail(data) {
    let url = this.PREFIX + "/stateItemInfo/stateItemDetailByBatchNo";
    return this.post(url, data);
  }
  /**
   * 上报立项
   *
   * @param {object} data
   * @param {strign} data.itemInfoId - 立项id
   * @param {string} data.transActors - 接收人
   *
   */
  reportItem(data) {
    let url = this.PREFIX + "/stateItemInfo/reportItem";
    return this.post(url, data);
  }
  /**
   *编辑出行路线
   *
   * @param {object} data
   * @param {string} [data.visitInfoId] - 出访路线id,编辑时必填
   * @param {string} data.itemInfoId - 立项id
   * @param {string} data.visitCountryCode - 出访国家编码
   * @param {string} data.visitCountryName - 出访国家
   * @param {string} data.entryDate - 入境日期
   * @param {string} data.inviUnitName - 邀请单位
   * @param {string} data.inviUnitNameEn - 邀请单位英文名
   * @param {string} data.stayDay - 停留天数
   * @param {string} data.depaDate - 离境日期
   * @param {string} data.entryCity - 入境城市
   * @param {string} data.depaCity - 出境城市
   * @param {string} data.visitReason - 出访事由
   * @param {string} data.signClassification - 签证种类,字典表
   * @param {string} data.signType - 签证类型,字典表
   * @param {string} data.inviter - 邀请人
   * @param {string} data.remarks - 备注
   * @param {string} data.inviPhone - 邀请电话
   * @param {string} data.inviAddr - 邀请地址
   * @returns
   * @memberof CompanyApi
   */
  editVisit(data) {
    let url = this.PREFIX + "/visa/visaInfo/editVisitInfo";
    return this.post(url, data);
  }
  /**
   *删除出访路线
   *
   * @param {object} data
   * @param {string} data.visitInfoId
   * @returns
   * @memberof CompanyApi
   */
  delVisit(data) {
    let url = this.PREFIX + "/visa/visaInfo/deleteVisit";
    return this.post(url, data);
  }
  editMutiVisit(data) {
    let url = this.PREFIX + "/visa/visaInfo/editVisitInfoBatch";
    return this.post(url, data);
  }
  /**
   *查询出访路线列表
   *
   * @param {object} data
   * @param {string} data.itemInfoId - 立项id
   * @returns
   * @memberof CompanyApi
   */
  getVisitList(data) {
    let url = this.PREFIX + "/visa/visaInfo/getVisitInfos";
    return this.post(url, data);
  }
  /**
   *获取出访路线详情
   *
   * @param {*} data
   * @returns
   * @memberof CompanyApi
   */
  getVisitDetail(data) {
    let url = this.PREFIX + "/visa/visaInfo/getVisitInfo";
    return this.post(url, data);
  }
  /**
   *删除成员
   *
   * @param {object} data
   * @param {string} data.signItemPersonId - 成员id
   * @returns
   * @memberof CompanyApi
   */
  delPerson(data) {
    let url = this.PREFIX + "/visa/signItemPerson/deletePerson";
    return this.post(url, data);
  }
  /**
   *获取成员列表
   *
   * @param {object} data
   * @param {string} data.itemInfoId 立项id
   * @returns
   * @memberof CompanyApi
   */
  getPersonList(data) {
    let url = this.PREFIX + "/visa/personInfo/getPersonInfos";
    return this.post(url, data);
  }
  /**
   *获取成员列表
   *
   * @param {object} data
   * @param {string} data.companyId
   * @param {string} data.name
   * @param {number} data.pageNo
   * @param {number} data.pageSize
   * @returns
   * @memberof CompanyApi
   */
  getAllPerson(data) {
    let url = this.PREFIX + "/visa/personInfo/getPersonList";
    return this.post(url, data);
  }
    /**
   *获取成员列表--立项填报第三步
   *
   * @param {object} data
   * @param {string} data.companyId
   * @param {string} data.name
   * @param {number} data.pageNo
   * @param {number} data.pageSize
   * @returns
   * @memberof CompanyApi
   */
  getPersonListItem(data) {
    let url = this.PREFIX + "/visa/personInfo/getPersonListItem";
    return this.post(url, data);
  }
  /**
   *获取延期列表
   *
   * @param {object} data
   * @param {string} data.itemInfoId
   */
  getDelayRecord(data) {
    let url = this.PREFIX + "/visa/travelInfo/getDelayRecord";
    return this.post(url, data);
  }
  getVisitReportByItemInfoId(data) {
    let url = this.PREFIX + "/visa/travelInfo/getVisitReportByItemInfoId";
    return this.post(url, data);
  }
  /**
   * 更新排序
   * @param {string} data.signItemPersonId
   * @param {string} data.orderNo
   *
   */
  updateOrder(data) {
    let url = this.PREFIX + "/visa/signItemPerson/updateOrder";
    return this.post(url, data);
  }
  //
  // http://web-law-dev.sedinbj.com.cn:8500/legal/#/login
  /**
   *获取立项成员详情
   *
   * @param {object} data
   * @param {string} data.signItemPersonId
   * @returns
   * @memberof CompanyApi
   */
  getPersonDetail(data) {
    let url = this.PREFIX + "/visa/signItemPerson/getPersonInfo";
    return this.post(url, data);
  }
  /**
   * @description 企业的撤回功能
   * @param {Object} data
   * @param {String} data.itemInfoId
   */
  undo(data) {
    let url = this.PREFIX + "/stateItemInfo/withdraw";
    return this.post(url, data);
  }
  /**
   * 上传指纹
   * @param {Object} data
   */
  upload(data) {
    let url = this.PREFIX + "/visa/personInfo/uploadZip";
    return this.post(url, data);
  }
  /**
   * 抄送
   * @param {Object} data
   */
  createWorkFlowTravel(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/createWorkFlowTravel";
    return this.post(url, data);
  }
  
  /**
   * 转办
   * @param {Object} data
   */
  transfer(data) {
    let url = this.PREFIX + "/workflow/stateItemInfo/transfer";
    return this.post(url, data);
  }
  /**
   * 判断oa第一次推送成行情况是已读还是未读（0 未读=待办、 1 已读=已办）
   * @param {Object} data
   */
  findMyCopyTask(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/findMyCopyTask";
    return this.post(url, data);
  }
  /**
   * 新增出行状况
   * @param {Object} data
   * @param {String} data.itemInfoId
   * @param {String[]} data.personInfoIds
   * @param {{acttualDepaDate:String,acttualEntryDate: String}[]} data.travelInfos
   */
  addVisitInfo(data) {
    let url = this.PREFIX + "/visa/travelInfo/saveTravel";
    return this.post(url, data);
  }
  /**
   * oa待办新增出行状况
   * @param {Object} data
   * @param {String} data.itemInfoId
   * @param {String[]} data.personInfoIds
   * @param {{acttualDepaDate:String,acttualEntryDate: String}[]} data.travelInfos
   */
  saveTravelWorkFlow(data) {
    let url = this.PREFIX + "/visa/travelInfo/saveTravelWorkFlow";
    return this.post(url, data);
  }
  
  /**
   * 出行状况列表
   * @param {Object} data
   * @param {String} data.itemInfoId
   */
  listVisitInfo(data) {
    let url = this.PREFIX + "/visa/travelInfo/list";
    return this.post(url, data);
  }
  /**
   * 删除出行状况
   * @param {{travelId: String}} data
   */
  delVisitInfo(data) {
    let url = this.PREFIX + "/visa/travelInfo/delete";
    return this.post(url, data);
  }
  /**
   * 退回出行状况
   * @param {{travelId: String}} data
   */
  backVisitInfo(data) {
    let url = this.PREFIX + "/visa/travelInfo/back";
    return this.post(url, data);
  }
  /**
   * 删除附件
   * @param {{travelFileId: String}} data
   */
  deleteFile(data) {
    let url =
      this.PREFIX + "/travelFile/deleteFile?travelFileId=" + data.travelFileId;
    return this.get(url, data);
  }
  /**
   * @author 王怀志
   * @param {{taskId: String}} data
   */
  fallbackStatus(data) {
    let url = this.PREFIX + "/visa/infoTask/fallbackStatus";
    return this.post(url, data);
  }
  //待上报状态 退回上一步
  backPrevious(data) {
    let url = this.PREFIX + "/visa/infoTask/backLastFoot";
    return this.post(url, data);
  }

  /**
   * 查看这次立项办理的证照
   * @param {{itemInfoId: String}} data
   */
  viewCertInfo(data) {
    let url = this.PREFIX + "/stateItemInfo/getCertInfo";
    return this.post(url, data);
  }

  /**
   * 查看日志
   *
   */
  getLogs(data) {
    let url = this.PREFIX + "/visa/itemOperate/getLogs";
    return this.post(url, data);
  }

  /**
   * 新增日志
   *
   */
  addLogs(data) {
    let url = this.PREFIX + "/visa/itemOperate/addLogs";
    return this.post(url, data);
  }

  /**
   *
   * 点击人员获取可选国家
   *
   */
  getVisaItemByPerson(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemByPerson";
    return this.post(url, data);
  }

  /**
   * 点击国家获取可选人员
   *
   *
   */
  getVisaItemByCountry(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemByCountry";
    return this.post(url, data);
  }

  /**
   * 获取可选择的国家
   * @param {String} data.itemInfoId 立项id
   *
   */
  getCountries(data) {
    let url = this.PREFIX + "/visa/visaInfo/getCountries";
    return this.post(url, data);
  }
  /**
   * 校验出访路线是否完成
   * @param {String} data.itemInfoId 立项id
   *
   */
  getCheckCountries(data) {
    let url = this.PREFIX + "/visa/visaInfo/checkCountries";
    return this.post(url, data);
  }
  /**
   * 校验出访路线日期是否合理
   * @param {String} data.itemInfoId 立项id
   *
   */
  checkDate(data) {
    let url = this.PREFIX + "/visa/visaInfo/checkDate";
    return this.post(url, data);
  }

  /**
   * 获取申办按钮权限
   *
   */
  checkRoleExist(data) {
    let url = this.PREFIX + "/common/checkRoleExist";
    return this.post(url, data);
  }

  /**
   * 提前制卡
   *
   */
  advanceApec(data) {
    let url = this.PREFIX + "/visa/infoTask/advanceApec";
    return this.post(url, data);
  }

  /**
   * 二次制卡
   */
  againApec(data) {
    let url = this.PREFIX + "/visa/infoTask/againApec";
    return this.post(url, data);
  }

  // 获取回访表
  getVisitRecord(data) {
    let url =
      this.PREFIX +
      "/visa/travelInfo/getVisitRecord?itemInfoId=" +
      data.itemInfoId;
    return this.get(url, data);
  }

  // 申办签证回显人员港澳证是否销旧办新
  getVisaItemUserByCountry(data) {
    let url = this.PREFIX + "/visa/infoTask/getVisaItemUserByCountry";
    return this.post(url, data);
  }
  //批量取走
  batchAddTakes(data) {
    let url = this.PREFIX + "/visa/infoTask/batchAddTakes";
    return this.post(url, data);
  }
  exportAllDetail(data) {
    // const now = new Date()
    // const yyyy = now.getFullYear()
    // const mm = String(now.getMonth() + 1).padStart(2, "0") // 月份从0开始
    // const dd = String(now.getDate()).padStart(2, "0")

    // const timestamp = now.getTime()

    // const fileName = `出国（境）业务办理文件明细表_${yyyy}${mm}${dd}_${timestamp}.xlsx`
    // data.fileName = fileName
    // let url = this.PREFIX + "/visa/stateItemInfo/exportDetail"
    // return http2.downloadFile(url, data, fileName)

    let url = this.PREFIX + "/visa/stateItemInfo/exportDetail";
    return this.downloadHttp.download2(url, data);
  }
  // 导出明细表(申办证照)
  exportDetailedList(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/exportPassportDetail";
    return this.downloadHttp.download2(url, data);
  }
  // 申请外事用印
  getSealWorkFlowInfo(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/getSealWorkFlowInfo";
    return this.post(url, data);
  }
  createSealTask(data) {
    let url = this.PREFIX + "/visa/stateItemInfo/createSealTask";
    return this.post(url, data);
  }
  
  // 批量接收
  receiverBatchTask(data) {
    let url = this.PREFIX + "/visa/infoTask/batchReceiveTask";
    return this.post(url, data);
  }
  //批量取走
  receiverBatchRetrieve(data) {
    let url = this.PREFIX + "/visa/infoTask/batchAddTakes";
    return this.post(url, data);
  }
}
